import { 
    CreateQuotationDto, 
    CustomRowsDto, 
    DeleteQuotationDto,
    EditQuotationDto,
    GetQuotationDto, 
    MessageResponseDto, 
    PackageInclusionsDto, 
    QuotationApiFp,
    QuotationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseQuotationModel = QuotationControllerGet200Response;
export type GetQuotationModel = GetQuotationDto;
export type MutateResponseQuotationModel = MessageResponseDto;
export type CreateQuotationModel = CreateQuotationDto;
export type UpdateQuotationModel = EditQuotationDto;
export type DeleteQuotationModel = DeleteQuotationDto;
export type CustomRowsModel = CustomRowsDto;
export type PackageInclusionsModel = PackageInclusionsDto;

export const apiQuotationFp = QuotationApiFp(apiConfig);
export const getQuotationController = apiQuotationFp.quotationControllerGet;
export const createQuotationController = apiQuotationFp.quotationControllerCreate;
export const updateQuotationController = apiQuotationFp.quotationControllerEdit;
export const deleteQuotationController = apiQuotationFp.quotationControllerDelete;

export const QueryKeyQuotation = QueryKey.Quotation;
